import React from 'react';
import Helmet from 'react-helmet';

import './scss/ProductDetail.scss';
import images from './images';
import globalImages from '../../global/images';

import tracking from '../../utils/tracking';
import {
  HEADER_COPY,
  COLOUR,
  IMAGE_NAME,
  BODY_COPY,
  TAGS
} from '../../utils/content-keys';

export default class ProductDetail extends React.Component {
  componentDidMount () {
    tracking.pageView(
      `/the-beers/${this.props.routeProps.match.params.beerId}`
    )
		window.scrollTo(0, 0)
	}

  uncleanString (title) {
    return title
      .trim()
      .split(' ')
      .join('-')
      .toLowerCase()
	}

  getProduct () {
    const { products, routeProps } = this.props
		const { beerId } = routeProps.match.params
		let productKey = -1

		Object.keys(products).some(key => {
      const item = products[key]

			if (!item.Header[0]) {
        return false
			}

      const productFound =
				this.uncleanString(item.Header[0][HEADER_COPY].value) === beerId &&
				item.Category[0][TAGS].value.toLowerCase() !== 'coming soon';

      if (productFound) {
        productKey = key
				return productFound
			}
    })

		if (productKey < 0) {
      return null
		}

    return products[productKey]
	}

  render () {
    const { products, routeProps } = this.props

		if (!products) {
      return null
		}

    const product = this.getProduct()

		if (!product) {
      return null
		}

    const bgColor = product.Header[0][COLOUR].value

		return (
      <div>
        <Helmet
          title={product.meta.title}
          meta={[{ name: 'description', content: product.meta.description }]}
          script={[
            {
              type: 'application/ld+json',
              innerHTML: `{
                "@context": "http://schema.org/",
                "@type": "Product",
                "name": "${product.Header[0][HEADER_COPY].value}",
                "image": "${product.Header[0][IMAGE_NAME].imgURL}",
                "description": "${product.Description[0][BODY_COPY].value}",
                "brand": {
                  "@type": "Thing",
                  "name": "Guinness"
                }
              }`
            }
          ]}
        />
        <div className='Product-detail__wrapper'>
          <div className='Product-detail__product-wrapper'>
            <div className='Product-detail__row' style={{ overflow: 'hidden' }}>
              <div
                className='Product-detail'
                style={{ backgroundColor: bgColor }}
              >
                <button
                  onClick={() => {
                    tracking.event('customEvent', {
                      eventCategory: 'Product Detail Back',
                      eventAction: 'click',
                      eventLabel: routeProps.location.pathname
                    })
										routeProps.history.goBack()
									}}
                  className='Product-detail__back'
                />
                <h2 className='Product-detail__title'>
                  {product.Header[0][HEADER_COPY].value}
                </h2>
                <img
                  className='Product-detail__image'
                  src={product.Header[0][IMAGE_NAME].imgURL}
                  alt=''
                />
              </div>
            </div>
          </div>
          <div className='Product-detail__detail-wrapper'>
            <div className='Product-detail__grid-wrapper'>
              {product.Exclusive &&
								product.Exclusive.length > 0 && (
                <div className='Product-detail__exclusive'>
                  <img
                    src={images[`exclusive_${bgColor.split('#')[1]}`]}
                    className='Product-detail__exclusive-logo'
                    alt=''
                  />
                  <h3 className='Product-detail__title Product-detail__title--exclusive'>
                    {product.Exclusive[0][HEADER_COPY].value}
                  </h3>
                </div>
              )}
              <div className='Product-detail__grid'>
                {product.Characteristics.map((char, index) => (
                  <div
                    className='Product-detail__grid-item'
                    key={`${this.props.beerId}_char_${index}`}
                    style={{ color: bgColor }}
                  >
                    <p className='Product-detail__grid-item-title'>
                      {char[HEADER_COPY].value}
                    </p>
                    <h5 className='Product-detail__grid-item-value'>
                      {char[BODY_COPY].value}
                    </h5>
                  </div>
                ))}
                {product.MaltsHops.map((malts, index) => (
                  <div
                    className='Product-detail__grid-item'
                    key={`${this.props.beerId}_malts_${index}`}
                    style={{ color: bgColor }}
                  >
                    <p className='Product-detail__grid-item-title'>
                      {malts[HEADER_COPY].value}
                    </p>
                    <h5 className='Product-detail__grid-item-value'>
                      {malts[BODY_COPY].value}
                    </h5>
                  </div>
                ))}
              </div>
            </div>

            <div className='Product-detail__more-details'>
              <h4 className='Product-detail__more-details-title'>
                {product.Description[0][HEADER_COPY].value}
              </h4>
              <p className='Product-detail__more-details-copy'>
                {product.Description[0][BODY_COPY].value}
              </p>
            </div>
          </div>
        </div>
      </div>
    )
	}
}



// WEBPACK FOOTER //
// ./src/pages/beers/ProductDetail.js